<template>
  <div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CRM_FETCH_STORE_DATA, CRM_LOGIN } from '@/store/helper/actions'
export default {
  name: 'CommonCRM',
  methods: {
    ...mapActions([
      CRM_LOGIN,
      CRM_FETCH_STORE_DATA
    ]),
    async connect() {
      await this.CRM_LOGIN()
      await this.CRM_FETCH_STORE_DATA()
    }
  },
  mounted(){
    this.connect()
  },
}
</script>

<style>

</style>